import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/cockpit.png'


const _hoisted_1 = {
  key: 0,
  class: "grid items-start grid-cols-3 gap-4 p-4 auto-cols-max place-content-start"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center w-full p-4 border-t\"><div class=\"\"><div class=\"w-8 h-8 bg-gray-500 rounded-full\"></div></div><div class=\"ml-4\"><div class=\"text-sm\">Mike testerson</div><div class=\"text-xs font-light\">flight #123</div></div></div>", 1)
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center w-full h-full mt-32 opacity-40"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "overflow-hidden rounded-full w-72 h-72" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pt-4 text-3xl font-light" }, "No assigned events today", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_event_card = _resolveComponent("event-card")

  return (_openBlock(), _createBlock("section", null, [
    (_ctx.scheduledEvents.length)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scheduledEvents, (event, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "inline-block h-full rounded shadow-md bg-primary-dark"
            }, [
              _createVNode(_component_event_card, {
                class: "p-4",
                event: event
              }, null, 8, ["event"]),
              _hoisted_2
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5
        ]))
  ]))
}